import { aiHttpClient as AiHttpClient } from '../../../../Common/api/ai_http_client';
import { httpClient } from '../../../../Common/api/http_client';

function createQueryString(queryObject) {
  let query = '';
  Object.keys(queryObject).forEach((item) => {
    query += `${item}=${queryObject[item]}&`;
  });

  return query;
}
/**
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getGeospatialStores() {
  return AiHttpClient.get('/geospatial/stores/');
}

/**
 *
 * @param filter
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getGeospatialProducts(filter) {
  return AiHttpClient.get(`/geospatial/products?${createQueryString(filter)}`);
}

/**
 *
 * @param period
 * @param filter
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getGeospatialSales(period, filter) {
  return AiHttpClient.get(`/geospatial/sales?filter=${period}&${createQueryString(filter)}`);
}

/**
 *
 * @param state
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getStoresByState(state) {
  return AiHttpClient.get(`/stores?state=${state}`);
}

export function getAllCountries() {
  return httpClient.get('/countries');
}
